import {CircleNode, CircleNodeModel, h} from '@logicflow/core';
import {resolveExecStyle} from '../../../exec-status';

// 自定义结束节点（圆形，带方形图标）
class EndNode extends CircleNode {
  getShape() {
    const {model} = this.props;
    const {x, y, r, properties} = model;
    const colors = resolveExecStyle(properties, {
      fill: '#FFF1F0',
      stroke: '#FF4D4F',
      text: '#FF4D4F',
      icon: '#FF4D4F',
    });

    const squareIcon = h('svg', {
      x: x - 8,
      y: y - 8,
      width: 16,
      height: 16,
      viewBox: '0 0 1024 1024',
      fill: colors.icon,
    }, [
      h('rect', {
        x: 0,
        y: 0,
        width: 1024,
        height: 1024,
      }),
    ]);

    return h('g', {}, [
      h('circle', {
        cx: x,
        cy: y,
        r,
        fill: colors.fill,
        stroke: colors.stroke,
        strokeWidth: 2,
      }),
      squareIcon,
    ]);
  }
}

// 自定义结束节点模型
class EndNodeModel extends CircleNodeModel {
  initNodeData(e) {
    super.initNodeData(e);
    this.r = 30; // 设置圆形节点的半径
    this.text = ''; // 结束节点通常不需要文本，所以设为空
    if (!this.properties || Object.keys(this.properties).length == 0) {
      this.properties = {
        name: '结束',
        status: '已闭合',
      };
    }
  }

  // 限制节点的连接逻辑：只能连入，不能连出
  setAllowLinkIn() {
    return true; // 允许进入的连线
  }

  setAllowLinkOut() {
    return false; // 禁止输出的连线
  }
}

export default {
  type: 'finish_node',
  view: EndNode,
  model: EndNodeModel,
};
